import React from "react"
import { Tab, Tabs, Paper } from "@material-ui/core"
import { trackActivity } from "../../../utils/mixpanel"
import { halcyonInstance, smbcInstance } from "../../../shared_elements/components"

const AssetListTab = ({ item, tabIndex, onTabChange }) => {
    return (
        <Paper  style={{marginBottom:'5px'}} className="assetList-tab">
            <Tabs
                value={tabIndex}
                onChange={onTabChange}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
            >
                {smbcInstance || halcyonInstance ? null : (
                    <Tab
                        label={`ALL (${item?.asset_count?.aircraft + item?.asset_count?.engine})`}
                        value={0}
                        onClick={() => trackActivity("Item Clicked", { page_title: "Asset Listing Tab", tab_name: "All" })}
                    />
                )}
                {smbcInstance || halcyonInstance ? null : (
                    <Tab
                        label={`Aircraft (${item?.asset_count?.aircraft})`}
                        value={1}
                        onClick={() => trackActivity("CAMO", { event_type: "Tab Clicked", page_title: "Asset Listing", tab_name: "Aircraft" })}
                    />
                )}
                <Tab
                    label={`Engine (${item?.asset_count?.engine})`}
                    value={2}
                    onClick={() => trackActivity("CAMO", { event_type: "Tab Clicked", page_title: "Asset Listing", tab_name: "Engine" })}
                />
            </Tabs>
        </Paper>
    )
}

export default AssetListTab
